import axios from "axios";
import Cookies from "js-cookie";
import { ROUTE } from "routes/route";

//apply base url for axios
// const REACT_APP_APP_URL = "https://mock.apidog.com/m1/412751-0-default/api/";
const REACT_APP_APP_URL = process.env.REACT_APP_APP_URL;
// const REACT_APP_APP_URL = "https://5e8f501dfe7f2a00165ef1cc.mockapi.io/cyan/";

const HEADERS_MULTIPLE_PART = {
  "Content-Type": "multipart/form-data; boundary=something",
};

let axiosApi = axios.create({
  baseURL: REACT_APP_APP_URL,
});

axiosApi.interceptors.request.use(function (config) {
  const access_token = Cookies.get("access_token");

  if (access_token) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }
  return config;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const logout = () => {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("USER_INFO");
  window.location.href = ROUTE.PUBLIC.LOGIN;
};

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error?.config;

    if (
      error?.response?.status == 401 &&
      originalRequest?.url !== "auth/signin" &&
      !originalRequest?._retry
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosApi(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refresh_token = Cookies.get("refresh_token");
      if (!refresh_token) {
        logout();
        return Promise.reject(error);
      }

      return new Promise((resolve, reject) => {
        axios
          .post(`${REACT_APP_APP_URL}auth/update-session`, {
            refresh_token: refresh_token,
          })
          .then((res) => {
            const newToken = res?.data?.data?.access_token;
            const newRefreshToken = res?.data?.data?.refresh_token;
            if (newToken) {
              Cookies.set("access_token", newToken);
              Cookies.set("refresh_token", newRefreshToken);
              originalRequest.headers.Authorization = `Bearer ${newToken}`;
              processQueue(null, newToken);
              resolve(axiosApi(originalRequest));
            } else {
              processQueue(error, null);
              logout();
              reject(error);
            }
          })
          .catch((err) => {
            processQueue(err, null);
            logout();
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return error?.response || Promise.reject(error);
  }
);

export async function get(url, config) {
  return axiosApi
    .get(url, {
      ...config,
    })
    .then((response) => response.data)
    .catch(
      (response) => {
        return response.data;
      },
      (err) => {
        return err.response || err;
      }
    );
}
export async function post(url, data, config) {
  return axiosApi
    .post(url, data, {
      ...config,
    })
    .then((response) => {
      return response?.data;
    })
    .catch(
      (response) => {
        return response.data;
      },
      (err) => {
        return err.response || err;
      }
    );
}
export async function put(url, data, config) {
  return axiosApi
    .put(url, data, {
      ...config,
    })
    .then((response) => response.data)
    .catch(
      (response) => {
        return response.data;
      },
      (err) => {
        return err.response || err;
      }
    );
}
export async function patch(url, data, config) {
  return axiosApi
    .patch(url, data, {
      ...config,
    })
    .then((response) => response.data)
    .catch(
      (response) => {
        return response.data;
      },
      (err) => {
        return err.response || err;
      }
    );
}
export async function del(url, data, config) {
  return axiosApi
    .delete(url, {data: data}, {
      ...config,
    })
    .then((response) => response.data)
    .catch(
      (response) => {
        return response.data;
      },
      (err) => {
        return err.response || err;
      }
    );
}

export async function postMultiplePart(url, data, config) {
  return axiosApi
    .post(url, data, {
      headers: HEADERS_MULTIPLE_PART,
      ...config,
    })
    .then((response) => response.data)
    .catch(
      (response) => {
        return response.data;
      },
      (err) => {
        return err.response || err;
      }
    );
}
